import { render } from "./LogActions.vue?vue&type=template&id=2f233b12&scoped=true"
import script from "./LogActions.vue?vue&type=script&lang=js"
export * from "./LogActions.vue?vue&type=script&lang=js"

import "./LogActions.vue?vue&type=style&index=0&id=2f233b12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f233b12"]])

export default __exports__